import React from 'react';
import { withRouter } from 'react-router-dom';
import Carousel from 'nuka-carousel';

import withWindowResize from '../ui/components/window-resize';
import NavArrow from '../shared/components/nav-arrow';
import ScrollEvent from '../shared/components/scroll-event';
import Link from '../shared/components/hyperlink';
import { Helpers } from '../core/src/helpers';
import { formatMetricValue } from '../metrics/metrics-helpers';

import './header.less';

class Header extends React.Component {
    static getDerivedStateFromProps(nextProps, state) {
        if (!state.initialSlide && nextProps.tabs.length && nextProps.selectedTab) {
            return { tabIndex: Header.getInitialSlide(nextProps), initialSlide: true };
        }
        return null;
    }

    static getInitialSlide(props) {
        let currentTabIndex = props.tabs.findIndex(tab => {
            return tab.identifier === props.selectedTab;
        });
        return currentTabIndex;
    }
    constructor(props) {
        super(props);
        this.renderTabs = this.renderTabs.bind(this);
        this.tabClick = this.tabClick.bind(this);
        this.tabs = [];
        this.state = {
            initialSlide: false,
            innerWidth: null,
            tabIndex: 0,
        };
    }

    fixedHeaderClassName() {
        if (this.props.fixedHeader) return ' fixed-header';
        else return '';
    }

    controls() {
        return {
            renderCenterLeftControls: NavArrow.PrevArrow,
            renderCenterRightControls: NavArrow.NextArrow,
            renderBottomCenterControls: () => <div></div>,
        };
    }

    checkTabIndex(tabIndex, slidesToShow) {
        let maxSlideIndex = this.props.tabs.length - slidesToShow;
        if (tabIndex < 0) return 0;
        if (tabIndex > maxSlideIndex) return maxSlideIndex;

        return tabIndex >= slidesToShow ? tabIndex : 0;
    }

    tabClick(tab) {
        const { history } = this.props;
        let location = { pathname: tab.path };
        let { _preview, pStoreID } = tab.search || {};
        if (tab.tabLink) {
            return;
        }
        if (_preview || pStoreID) {
            location.search = '?' + Helpers.paramsToString({ _preview, pStoreID }, false);
        }

        tab.path && history.push(location);
        tab.onTabClick && tab.onTabClick();
    }

    handleKeyup = (e, index) => {
        e.preventDefault();
        let charCode = e.keyCode || e.which;

        if (charCode === 37) {
            //when left arrow key is pressed
            this.setTabFocus(index - 1);
        } else if (charCode === 39) {
            //when right arrow key is pressed
            this.setTabFocus(index + 1);
        }
    };

    setTabFocus = index => {
        if (index >= 0 && index < this.props.tabs.length) {
            this.tabs[index].focus();
        }
    };

    renderTabs() {
        const { tabs, selectedTab, templateKey } = this.props;
        const isGiftGuide = typeof templateKey === 'string' && /gift\-guide/i.test(templateKey);
        return tabs.map((tab, index) => {
            //if no tabLink use frafment isntead of link component
            let WrapperComponent = React.Fragment;
            let wrappProps = {};
            const activated = tab.identifier === selectedTab ? 'activated' : '';
            if (tab.tabLink) {
                wrappProps.to = tab.tabLink;
                WrapperComponent = Link;
            }
            let { name } = tab || {};
            const tabProps = isGiftGuide
                ? {
                      'data-gtm-category': 'linkClick',
                      'data-gtm-value': typeof name === 'string' ? formatMetricValue(name) : '',
                      'data-gtm-id': 'product-type-bar',
                  }
                : {};
            return (
                <button
                    onKeyUp={e => this.handleKeyup(e, index)}
                    tabIndex={activated ? 0 : -1}
                    id={`tab_${index}`}
                    className={`tabs-link-container ${activated} unstyled`}
                    key={index}
                    ref={tabRef => (this.tabs[index] = tabRef)}
                    onClick={() => this.tabClick(tab)}
                    aria-label={name}
                    {...tabProps}
                >
                    <WrapperComponent {...wrappProps}>
                        <div className="tabs-link">
                            {!tab.icon ? (
                                <div className={'hp-icon ' + tab.className}></div>
                            ) : (
                                <div className="hp-icon">
                                    <span className="icon" dangerouslySetInnerHTML={Helpers.createMarkup(tab.icon)} />
                                </div>
                            )}
                            <p className="tab-title">{name}</p>
                            <div
                                className={
                                    this.props.selectedTab === tab.identifier ? 'selected-bar active' : 'selected-bar'
                                }
                            ></div>
                        </div>
                    </WrapperComponent>
                </button>
            );
        });
    }

    render() {
        const { device, width, tabs } = this.props;
        const { tabIndex } = this.state;
        //TODO: temp fix until we can figure out why the resize event is giving us the wrong width in the ui redux state
        const maxSlides = device === 'mobile' ? 3 : tabs.length;

        if (tabs.length < 2) return <div className="header-wrapper" />;

        let carouselOn = false;

        let slidesToShow;
        if (!this.widthSum) {
            this.widthSum = this.tabs.reduce((sum, tab) => {
                return sum + parseFloat(getComputedStyle(tab).width);
            }, 0);
        }

        if (this.widthSum && this.widthSum > width) {
            carouselOn = true;
            slidesToShow = Math.min(Math.floor((width / this.widthSum) * tabs.length), maxSlides);
        }

        const settings = {
            slidesToShow,
            slideIndex: this.checkTabIndex(tabIndex, slidesToShow),
            afterSlide: x => this.setState({ tabIndex: x }),
            ...this.controls(),
        };
        return (
            <ScrollEvent>
                {(attachRef, scrollState) => (
                    <div className={`header-wrapper${scrollState.isSticky ? ' fixed-header' : ''}`} ref={attachRef}>
                        <div className="tabs-nav">
                            {carouselOn ? <Carousel {...settings}>{this.renderTabs()}</Carousel> : this.renderTabs()}
                        </div>
                    </div>
                )}
            </ScrollEvent>
        );
    }
}

export default withRouter(withWindowResize(Header));
